if (!customElements.get('mega-menu-sidebar')) {
  class MegaMenuSidebar extends HTMLElement {
    connectedCallback() {
      this.images = this.querySelectorAll('img');
      window.addEventListener('load', () => {
        this.images.forEach((img) => {
          if (typeof lazySizes !== 'undefined') lazySizes.loader.unveil(img);
        });
      });
    }
  }
  customElements.define('mega-menu-sidebar', MegaMenuSidebar);
}
